import { type AssetType } from "@doitintl/cmp-models";
import { Alert, AlertTitle, Button, Typography } from "@mui/material";

import { getBucketTypeDisplayName, getIndefiniteArticle } from "./utils";

const createBucketButtonText = (assetType: AssetType) => {
  const assetTypeText = getBucketTypeDisplayName(assetType);

  return `Create ${getIndefiniteArticle(assetTypeText ?? "")} ${assetTypeText} bucket`;
};

const BucketCreatePlaceholder = ({
  assetType,
  openCreateBucketForm,
}: {
  assetType: AssetType;
  openCreateBucketForm: (assetType: AssetType) => void;
}) => (
  <Alert
    severity="info"
    action={
      <Button
        color="inherit"
        onClick={() => {
          openCreateBucketForm(assetType);
        }}
      >
        Create
      </Button>
    }
  >
    <AlertTitle>{createBucketButtonText(assetType)}</AlertTitle>
    <Typography variant="body2">
      At least one bucket is required for each asset type. Please create a bucket for{" "}
      {getBucketTypeDisplayName(assetType)}.
    </Typography>
  </Alert>
);

export default BucketCreatePlaceholder;
